import { onScreen } from 'Lib/on-screen/on-screen';

onScreen($('.bg_check-show-position, .bg_dark-wood, .bg_14-february, .bg_23-february, .bg_sales-main, .bg_8-marta, .bg_oge-ege, .bg_ready-school'), ($el) => {
    $el.addClass('bg_show-position');
});